export const thunkTypes = {
  GET_SUMMARY: `referralsBackoffice/getSummary`,
  GET_WEEKLY_TREND: `referralsBackoffice/getWeeklyTrend`,
  GET_SUPERVISOR_AMBASSADORS: `referralsBackoffice/getSupervisorAmbassadors`,
  LIST_ZONES: `referralsBackoffice/listZones`,
  LIST_REFERRALS: `referralsBackoffice/listReferrals`,
  FETCH_ALL_REFERRALS: `referralsBackoffice/fetchAllReferrals`,
  GET_REFERRAL: `referralsBackoffice/getReferral`,
  LIST_LINK_CANDIDATES: `referralsBackoffice/listLinkCandidates`,
  LINK_REFERRAL: `referralsBackoffice/linkReferral`,
  UNLINK_REFERRAL: `referralsBackoffice/unlinkReferral`,
  UPDATE_REFERRAL_STATUS: `referralsBackoffice/updateReferralStatus`,
};
